



















import { Component, Vue } from 'vue-property-decorator';
import InNeedOfActionCard from '@/components/InNeedOfActionCard.vue';
import Form from '@/classes/Form';

@Component({
    components: {
        InNeedOfActionCard
    }
})
export default class Home extends Vue {
    public sendTo(destination: string): void {
        this.$router.push('/forms/' + destination);
    }

    get actionableForms(): Form[] {
        const forms: Form[] = this.$store.getters.getFormsInNeedOfAction;
        return forms;
    }
}
